/** Identifies the three resource categories available for linking. */
export var ResourceTab = /*#__PURE__*/function (ResourceTab) {
  ResourceTab["REPORTS"] = "reports";
  ResourceTab["APPOINTMENTS"] = "appointments";
  ResourceTab["ENCOUNTERS"] = "encounters";
  return ResourceTab;
}({});

/** A single tab in the modal header with a display count. */

/** Props for the outer LinkPatientRecordsModal component. */

/** Props for the modal's tab-based header. */

/** Props for the modal footer with action buttons. */

/** Props for the checkbox-and-card selection wrapper. */

/** Props for the IntersectionObserver-based scroll sentinel. */

/** Props for the internal labeled-field helper rendered inside AppointmentItem. */

/** Props for a simplified appointment card. */

/** Props for a simplified encounter card. */

/** Props for the hook that backs the modal. */